export default __webpack_public_path__ + "static/media/algerie.db5bf702.svg";